import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ApiService } from '@services';

/**
 * Wisper users service.
 *
 * @author Ihar Kazlouski
 * @class WisperUsersServiceClass
 * @category Services
 */
var WisperUsersServiceClass = /*#__PURE__*/function () {
  function WisperUsersServiceClass() {
    _classCallCheck(this, WisperUsersServiceClass);
  }

  _createClass(WisperUsersServiceClass, [{
    key: "apiWisperUsersGet",
    value:
    /**
     * Wisper users get api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<WiperUsersResponseType>>} accounts list promise.
     */
    function () {
      var _apiWisperUsersGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", ApiService.apiGet('/wisper-users', _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function apiWisperUsersGet(_x) {
        return _apiWisperUsersGet.apply(this, arguments);
      }

      return apiWisperUsersGet;
    }()
    /**
     * Wisper users filter post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<WiperUsersResponseType>>} wisper users list promise.
     */

  }, {
    key: "apiSearchWisperUsersPost",
    value: function () {
      var _apiSearchWisperUsersPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", ApiService.apiPost('/wisper-users/search', _objectSpread({}, params.body), _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function apiSearchWisperUsersPost(_x2) {
        return _apiSearchWisperUsersPost.apply(this, arguments);
      }

      return apiSearchWisperUsersPost;
    }()
    /**
     * Wisper users user update put api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>} promise.
     */

  }, {
    key: "apiUpdateWisperUserPut",
    value: function () {
      var _apiUpdateWisperUserPut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id, params) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", ApiService.apiPut("/wisper-user/".concat(id), _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function apiUpdateWisperUserPut(_x3, _x4) {
        return _apiUpdateWisperUserPut.apply(this, arguments);
      }

      return apiUpdateWisperUserPut;
    }()
    /**
     * Wisper users user post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>} promise.
     */

  }, {
    key: "apiAddWisperUserPost",
    value: function () {
      var _apiAddWisperUserPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, params) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", ApiService.apiPost("/wisper-users/".concat(id), params === null || params === void 0 ? void 0 : params.body, _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function apiAddWisperUserPost(_x5, _x6) {
        return _apiAddWisperUserPost.apply(this, arguments);
      }

      return apiAddWisperUserPost;
    }()
    /**
     * Wisper users user update put api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>} promise.
     */

  }, {
    key: "apiAssignAsAdminWisperUserPut",
    value: function () {
      var _apiAssignAsAdminWisperUserPut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, params) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", ApiService.apiPut("/wisper-user/assign-as-admin/".concat(id), _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function apiAssignAsAdminWisperUserPut(_x7, _x8) {
        return _apiAssignAsAdminWisperUserPut.apply(this, arguments);
      }

      return apiAssignAsAdminWisperUserPut;
    }()
  }]);

  return WisperUsersServiceClass;
}();

var WisperUsersService = new WisperUsersServiceClass();
export { WisperUsersService };